export default __webpack_public_path__ + "static/media/palmpay-logo.207193e0.svg";